import { commentItems } from '@/mocks/homeData';

export default function Comments() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">吃瓜热评</h2>
          <p className="mt-2 text-sm text-foreground-500">网友热议最新网红黑料，看看大家都怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {commentItems.map((comment, i) => (
            <div
              key={i}
              className={`bg-background-100/80 rounded-xl border border-background-200/60 p-5 ${
                i === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className="flex items-start gap-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                  width="80"
                  height="80"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{comment.name}</span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{comment.time}</span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
                  <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                      <i className="ri-thumb-up-line"></i> {comment.likes.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                      <i className="ri-chat-1-line"></i> 回复
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}